<template>
    <v-app id="dashboard-app">
        <AppBar />
        <Drawer />

        <v-content>
            <router-view/>
        </v-content>

        <AppSnackbar />
        <AppConfirm />
    </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';
import Drawer from '@/components/Drawer';
import AppSnackbar from '@/components/AppSnackbar';
import AppConfirm from '@/components/AppConfirm';

export default {
name: 'DefaultLayout',
components: {
  AppBar,
  Drawer,
  AppSnackbar,
  AppConfirm
},
data: () => ({
  expandOnHover: false
}),
};
</script>

<style scoped>

</style>
